import { FC, useEffect, useState } from 'react';

import { useNews } from 'hooks/useNews';
import { usePageTitle } from 'hooks/usePageTitle';

import { isLatestNews } from 'utils/isLatestNews';

import styles from './News.module.scss';

export const News: FC = () => {
  const newsData = useNews();
  const [isLatestArray, setIsLatestArray] = useState<boolean[]>([]);

  usePageTitle(`お知らせ`);

  useEffect(() => {
    if (newsData) {
      setIsLatestArray(newsData.map(news => isLatestNews(news.date)));
    }
  }, [newsData]);

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [newsData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          {newsData && (
            <ol className={styles.news}>
              {newsData.map((news, index) => {
                return (
                  <li key={index} id={news.number} className={styles.newsItem}>
                    <div className={styles.newsHead}>
                      <p className={styles.newsDate}>{news.date}</p>
                      {isLatestArray[index] && <p className={styles.newsLatest}>NEW</p>}
                    </div>
                    <div className={styles.newsBody}>
                      <h1 className={styles.newsTitle}>{news.title}</h1>
                      <div
                        dangerouslySetInnerHTML={{ __html: news.content }}
                        className={styles.newsContent}
                      />
                    </div>
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};
